<template>
    <div class="container-fluid">
        <nav class="navbar navbar-expand d-flex justify-content-end">
            <div class="navbar-nav" v-if="isAuthenticated">
                <div class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="exit">Выход</a>
                </div>
            </div>
            <div class="navbar-nav" v-else>
                <div class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="login">Вход</a>
                </div>
                <div class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="registration">Регистрация</a>
                </div>
            </div>
        </nav>
        <loading :active="isLoading" :is-full-page="true">
        </loading>
        <router-view></router-view>
    </div>
    <div class="modal-form" v-show="isShowLogin">
        <div class="modal-form-content">
            <UserLogin @close-modal="isShowLogin=false" v-bind:key="userLoginKey" :initial-operation="loginDialogOperation"></UserLogin>
        </div>
    </div>

</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex'
    import Loading from 'vue3-loading-overlay';
    import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
    import UserLogin from "@/components/UserLogin";

    export default {
        name: 'App',
        components: {
            UserLogin,
            Loading
        },
        data: function () {
            return {
                isLoading: false,
                isShowLogin: false,
                userLoginKey: 0,
                loginDialogOperation: 'login'
            }
        },
        mounted() {
            this.reload();
        },
        computed: {
            ...mapGetters([
                'isAuthenticated'
            ]),
            ...mapState({
                template: state => state.template
            })
        },
        methods: {
            ...mapActions([
                'getCurrentTemplate',
                'getCurrentTemplateValues',
                'logout'
            ]),
            async reload() {
                this.isLoading = true
                try {
                    await this.getCurrentTemplate()
                    if (this.isAuthenticated) {
                        await this.getCurrentTemplateValues()
                    }
                    this.isLoading = false
                } catch (err) {
                    console.log(err)
                    this.isLoading = false
                }
            },
            async exit() {
                this.isLoading = true
                try {
                    await this.logout()
                    await this.reload()
                    this.isLoading = false
                } catch (err) {
                    console.log(err)
                    this.isLoading = false
                }
            },
            login() {
                this.loginDialogOperation = 'login'
                this.userLoginKey ++
                this.isShowLogin=true
            },
            registration() {
                this.loginDialogOperation = 'registration'
                this.userLoginKey ++
                this.isShowLogin=true
            },
        }
    }
</script>

<style lang="scss">

    @import '~primevue/resources/themes/lara-light-teal/theme.css';

    #app .ql-bubble .ql-tooltip {
        z-index: 1000;
    }

    #app .modal-form {
        display: block; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 1000; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }

    #app .modal-form-content {
        margin: 15% auto;
        border: 1px solid #888;
        width: 80%;
    }

    #app .ql-container {
        font-size: inherit !important;
    }

    #app .ql-editor {
        padding: 0 !important;
    }

    #app .modal-form {
        display: block; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 1000; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }

</style>
<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        margin-top: 60px;
        font-size: 0.85rem;
    }
</style>
